import { createApp } from 'vue';
import HomeView from '../../free/HomeView.vue'

const appElements = document.querySelectorAll('.vue-home-view')
Array.from(appElements).forEach(element => {
  createApp(HomeView).mount(element);
});